// @ts-nocheck TODO

import {html, LitElement} from "lit";
import {customElement, property} from "lit/decorators.js";
import {classMap} from "lit/directives/class-map.js";
import {unsafeHTML} from "lit-html/directives/unsafe-html.js";
import {commonStyles} from "../../common/styles/Common.js";
import Utils from "../../../main/utils/index.js";
import {annotationDragStyles} from "./AnnotationDragState.styles.js";

import {DragData} from "./drag_utils.js";

@customElement("pn-annotation-drag")
export class AnnotationDragState extends LitElement {
	static styles = [commonStyles, annotationDragStyles];

	@property() data: DragData;

	getContent() {
		switch (this.data.type) {
			case "freeform":
				return html`${unsafeHTML(this.data.comment)}`;

			case "bookmark":
				return html`${this.data.pageTitle}`;

			case "highlight":
				return html`“${this.data.quote}”`;

			case "image": {
				if (window?.LEO?.urls?.assets) {
					if (this.data.thumbnailSrc) {
						return html`<img
							alt="Thumbnail"
							src=${this.data.thumbnailSrc}
						/>`;
					} else {
						// If there is no thumbnail img for some reason, just
						// show the PN logo
						return html`<img
							alt="Thumbnail"
							src="${Utils.Common.imgPath("powernotes_p_logo.svg")}"
						/>`;
					}
				} else {
					// For storybook only
					const imgSrc = "https://upload.wikimedia.org/wikipedia/commons/thumb/8/83/Mar_de_Siete_Colores_-_West_%288331578284%29.jpg/1024px-Mar_de_Siete_Colores_-_West_%288331578284%29.jpg";

					return html`<img
						alt="Thumbnail"
						src=${imgSrc}
					/>`;
				}
			}

			default:
				return null;
		}
	}

	render() {
		const {type} = this.data;

		return html`
			<div id="container" data-type=${this.data.type}>
				<img
					id="logo"
					alt="PowerNotes logo"
					src="${Utils.Common.imgPath("powernotes_p_logo.svg")}"
				/>

				<div id="content" class=${classMap({
					"link-style": type === "bookmark"
				})}>
					${this.getContent()}
				</div>
			</div>
		`;
	}
};

declare global {
	interface HTMLElementTagNameMap {
		"pn-annotation-drag": AnnotationDragState;
	}
}
